import { Link } from 'react-router-dom';

export const CategoryGrid = ({ categories }: { categories: string[] }) => (
  <div className="category-grid">
    {categories.map((category) => (
      <Link key={category} className="category-card" to={`/categories/${category.toLowerCase()}`}>
        <div className="category-card__info">
          <h2>{category}</h2>
          <p>Explore articles on {category.toLowerCase()}.</p>
        </div>
        <span className="category-card__arrow">→</span>
      </Link>
    ))}
  </div>
);
